export const PropertyTypesWeBuy = () => {
  const propertyTypes = [
    {
      icon: 'ri-building-4-line',
      title: 'Urban Mid-Rise',
      description: 'Downtown and city center properties with 4-8 stories, often with ground-floor retail or parking.',
      features: ['Prime locations', 'Mixed-use potential', 'High walkability scores', 'Transit access']
    },
    {
      icon: 'ri-community-line',
      title: 'Suburban Mid-Rise',
      description: 'Properties in suburban town centers and transit-oriented developments with modern amenities.',
      features: ['Family-friendly', 'Parking included', 'Community amenities', 'School districts']
    },
    {
      icon: 'ri-building-2-line',
      title: 'Elevator Buildings',
      description: 'Full-service buildings with elevators, doormen, and premium amenities for upscale tenants.',
      features: ['Concierge service', 'Fitness centers', 'Rooftop access', 'Premium finishes']
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Value-Add Properties',
      description: 'Mid-rise buildings needing renovation, repositioning, or improved management to maximize value.',
      features: ['Below-market rents', 'Deferred maintenance', 'Management issues', 'High upside potential']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Types of Mid-Rise Properties We Buy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We purchase all types of mid-rise apartment buildings, from stabilized assets to value-add opportunities requiring significant capital investment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {propertyTypes.map((type, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 hover:shadow-xl transition-all duration-300">
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                  <i className={`${type.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-gray-900">{type.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{type.description}</p>
                </div>
              </div>
              <div className="border-t border-gray-300 pt-6">
                <h4 className="font-semibold mb-3 text-gray-900">Key Features:</h4>
                <ul className="grid grid-cols-2 gap-3">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-teal-500 mr-2"></i>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-8 md:p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">Not Sure If Your Property Qualifies?</h3>
            <p className="text-xl mb-8 text-white/95 leading-relaxed">
              Every mid-rise property is unique. Whether you have a trophy asset or a challenging value-add opportunity, we'd like to hear about it. Our team can evaluate any mid-rise apartment building and provide a fair, competitive offer.
            </p>
            <a 
              href="#get-offer" 
              className="whitespace-nowrap inline-block bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Tell Us About Your Property
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};